import { Lock } from "lucide-react";
import { useStore } from "@/store/AppStore";
import { PageHeader, Panel } from "@/components/kit";
import { AccessSheet } from "@/components/Accesses";
import { PROFILES } from "@/data/mock";

export default function CollabAccess() {
  const { state } = useStore();
  const { collaboratorId, companyId } = PROFILES.colaboradora;
  const me = state.collaborators.find((c) => c.id === collaboratorId);
  return (
    <div data-testid="collab-access-page">
      <PageHeader eyebrow="Acessos" title="Acessos da empresa" subtitle="Consulta liberada pela empresária." />
      {me?.accessAllowed ? <AccessSheet companyId={companyId} /> : (
        <Panel testId="collab-access-denied"><p className="flex items-center gap-2 text-sm text-neutral-500"><Lock className="h-4 w-4 text-gold" /> Você ainda não tem autorização para ver os acessos. Fale com a empresária.</p></Panel>
      )}
    </div>
  );
}
